import React from 'react'
import UiKit from "../../../../common/uikit"
import Contact from "./contact.png"

const ContactForm = () => {
    return (
        <div className="contact-form">
            <div className="header">
                <img src={Contact}/>
            </div>
            <form className="form-wrapper">
            <UiKit.Row className="mt25" >
                <UiKit.Col sm="12" md="12">
                   <h1 className="osman">Drop Us a Line</h1>
                </UiKit.Col>
            </UiKit.Row>
            <UiKit.Row className="mt25">
                <UiKit.Col sm="12" md="12">
                    <UiKit.Textfield
                        full
                        required
                        // maxLength   = { 32 }
                        placeholder = "Ad Soyad Giriniz"
                        // value       = { s.form.firstName }
                        // onChange    = { value => changeFormValues('firstName', value) }
                        // errors      = { s.errors['firstName']}
                        // attrs       = {{ id : 'sign-up-first-name' }}
                        // isDisabled  = { redux.isLoading }
                    />
                </UiKit.Col>
            </UiKit.Row>
            <UiKit.Row className="mt25">
                <UiKit.Col className="pr8" sm="6" md="6">
                    <UiKit.Textfield
                        full
                        required
                        // maxLength   = { 32 }
                        placeholder    = "Sirket Adini Giriniz"
                        // value       = { s.form.firstName }
                        // onChange    = { value => changeFormValues('firstName', value) }
                        // errors      = { s.errors['firstName']}
                        // attrs       = {{ id : 'sign-up-first-name' }}
                        // isDisabled  = { redux.isLoading }
                    />
                </UiKit.Col>
                <UiKit.Col className="pl8" sm="6" md="6">
                    <UiKit.Textfield
                        full
                        required
                        // maxLength   = { 32 }
                        placeholder    = "Email Giriniz"
                        // value       = { s.form.lastName }
                        // onChange    = { value => changeFormValues('lastName', value) }
                        // errors      = { s.errors['lastName'] }
                        // attrs       = {{ id : 'sign-up-last-name' }}
                        // isDisabled  = { redux.isLoading }
                    />
                </UiKit.Col>
            </UiKit.Row>
            <UiKit.Row className="mt25">
                <UiKit.Col  sm="12" md="12">
                    <UiKit.Textarea
                        full
                        // className   = "mb5"
                        maxLength   = { 100 }
                        // attrs       = {{ id: 'edit-reservation-customer-note' }} 
                        placeholder = "İletmek istediğinizi giriniz."
                        // onClick     = { () => focusInputEl('edit-reservation-customer-note') }
                        // onBlur      = { () => blurInputEl() }
                        // onChange    = { value => { p.changeReservationModel('note', value) } }
                        // value       = { p.editReservation.note }
                    />
                </UiKit.Col>
            </UiKit.Row>
            <UiKit.Row>
                    <UiKit.Col className="mt20" sm="12" md="12">
                        <button  className="yolla" style={{width:"100%", height:"100%"}}>Yolla</button>
                    </UiKit.Col>
                </UiKit.Row>
            </form>
        </div>
    )
}

export default ContactForm
